import { render, staticRenderFns } from "./CasesSlide.vue?vue&type=template&id=4d606ef7&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CasesSlide.vue"
export default component.exports